import React from 'react'
import TableProfileListPage from './TableProfileListPage'
import CreateTableProfilePage from './CreateTableProfilePage'
import EditTableProfilePage from './EditTableProfilePage'

const TableProfileRoutes = [
  {
    breadcrumb: 'Table Profile List',
    path: '',
    element: <TableProfileListPage />,
    children: [],
  },
  {
    breadcrumb: 'Create Table Profile',
    path: 'create',
    element: <CreateTableProfilePage />,
  },
  {
    breadcrumb: 'Table Profile Detail',
    path: ':id',
    element: <EditTableProfilePage />,
  },
]

export default TableProfileRoutes
